import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import { triggerBase64Download } from "common-base64-downloader-react";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { DASHBOARD_GREEN, EMPLOYEE_BLUE, PINK_RED, WHITE } from "../colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HeightBox from "../components/HeightBox";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import CustomerListContainer from "../containers/CustomersListContainer";
import SingleUserDetailsContainer from "../containers/SingleUserDetailsContainer";

import AddFormDocumentModel from "../components/AddFormDocumentModel";
import CustomerService from "../services/customerService";
import { useHistory } from "react-router-dom";
import { AddFinancialRecordContainerModel } from "../containers/AddFinancialRecordModelContainer";
import AddRemarkModal from "../components/AddRemarksModel";
import { CUSTOMER } from "../constants/userCategory";

import { getAllCustomers } from "../actions/customers";

import { ConstructionOutlined } from "@mui/icons-material";
import DownloadService from "../services/downloadService";
import Banner from "../components/banners/Banner";
import { autocompleteClasses } from "@mui/material";

const CustomInput = styled(Input)(({ theme }) => ({
  backgroundColor: "#fff",
  paddingLeft: 10,
  height: 50,
  width: 320,
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  height: 50,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const CustomButtonHQ = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  height: 50,
  padding: "0 30px",
  float: "right",
  color: WHITE,
  textTransform: "none",
  margin: "auto",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const CustomerList = () => {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const { loading: isDataLoaded, error, customers } = customerList;

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const [userClicked, setUserClicked] = useState(
    params.id ? customers?.find((customer) => parseInt(params.id) === parseInt(customer.id)) : null
  );

  const [showAddFormModel, setShowAddFormModel] = useState(false);
  const [showFRModel, setShowFRModel] = useState(false);
  const [showRemarkModel, setShowRemarkModel] = useState(false);
  const [searchedCustomer, setSearchedCustomer] = useState("");
  const [customersSearching, setCustomersSearching] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    customers: [],
    searchedCustomers: [],
  });

  let history = useHistory();

  useEffect(() => {
    const getPageInfo = async () => {
      if (customers === null) {
        dispatch(getAllCustomers());
      }
      setScreenInfo({
        ...screenInfo,
        customers: customers,
        searchedCustomers: customers,
      });
    };

    getPageInfo();
  }, []);

  useEffect(() => {
    if (searchedCustomer.length === 0) {
      setCustomersSearching(false);
    } else {
      const searchedUsers = customers?.filter(
        (value) =>
          value?.full_name.toLocaleUpperCase().includes(searchedCustomer.toLocaleUpperCase()) ||
          value?.nic.toLocaleUpperCase().includes(searchedCustomer.toLocaleUpperCase()) ||
          value?.reg_number.toLocaleUpperCase().includes(searchedCustomer.toLocaleUpperCase())
      );
      setScreenInfo({
        ...screenInfo,
        searchedCustomers: searchedUsers,
      });
      setCustomersSearching(true);
    }
  }, [searchedCustomer]);

  const dowloadDocsForHQ = async () => {
    setIsDownloading(true);
    try {
      const encodedResponse = await DownloadService.getMergedDocsToHQ({ customerId: userClicked.id });
      const base64data = "data:application/pdf;base64," + encodedResponse.data;
      triggerBase64Download(base64data, "download_name");
    } catch (e) {
      alert(e.response.data?.message);
    }
    setIsDownloading(false);
    // if (encodedResponse.status == 400) {

    // }
    // const base64data = "data:application/octet-stream;base64," + encodedResponse.data.data;
    // triggerBase64Download(base64data, "download_name");
  };
  return (
    <div>
      <AddFormDocumentModel
        openModel={showAddFormModel}
        userId={userClicked?.id ? userClicked?.id : null}
        okFunction={() => {
          setShowAddFormModel(false);
        }}
        cancelFunction={() => {
          setShowAddFormModel(false);
        }}
      />
      <AddFinancialRecordContainerModel
        openModel={showFRModel}
        okFunction={() => {
          setShowFRModel(false);
        }}
        cancelFunction={() => setShowFRModel(false)}
      />
      <AddRemarkModal
        openModel={showRemarkModel}
        okFunction={() => {
          setShowRemarkModel(false);
        }}
        cancelFunction={() => setShowRemarkModel(false)}
      />
      <Stack direction="row" alignItems="center" spacing={3}>
        {userClicked !== null && (
          <IconButton onClick={() => setUserClicked(null)}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <CustomInput
          disableUnderline
          value={searchedCustomer}
          onChange={(event) => setSearchedCustomer(event?.target?.value)}
          placeholder="Search Candidate"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
        {userClicked !== null && (
          <Stack direction="column" spacing={1}>
            <Stack direction="row" spacing={1}>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE, fontSize: 14 }}
                onClick={() => history.push(`/form-submit?type=ApplicationForm&customer=${userClicked.id}`)}
              >
                Add form
              </CustomButton>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE, fontSize: 14, boxShadow: 1 }}
                onClick={() => setShowAddFormModel(true)}
              >
                Add media
              </CustomButton>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE, fontSize: 14 }}
                onClick={() => setShowFRModel(true)}
              >
                Add FR
              </CustomButton>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE, fontSize: 14 }}
                onClick={() => setShowRemarkModel(true)}
              >
                Add Remark
              </CustomButton>
            </Stack>
            <CustomButtonHQ
              style={{ backgroundColor: DASHBOARD_GREEN, fontSize: 14 }}
              disabled={isDownloading}
              onClick={() => dowloadDocsForHQ()}
            >
              {isDownloading ? <CircularProgress size={15} /> : "Send to HQ"}{" "}
            </CustomButtonHQ>
          </Stack>
        )}
      </Stack>
      <HeightBox height={20} />
      {userClicked === null && isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {userClicked === null && !isDataLoaded && (
        <CustomerListContainer
          userClicked={(user) => {
            setUserClicked(user);
          }}
          customers={customersSearching ? screenInfo.searchedCustomers : screenInfo.customers}
        />
      )}
      {/* <Banner message="hi" severity="warning" /> */}
      {userClicked !== null && <SingleUserDetailsContainer user={userClicked} userRole={CUSTOMER} />}
    </div>
  );
};

export default CustomerList;
